import { createSelector } from "reselect";
import { sharedLib } from "@shared/services/shared.service";

export const selectSubGroupUsers = (subGroupID: number) =>
  createSelector(
    sharedLib.sharedApi.admin.endpoints.getAdminSubGroupData.select({
      sub_group_id: subGroupID,
    }),
    ({ data: subGroup }) => {
      return subGroup ? subGroup.members : [];
    }
  );

export const selectSubGroupInvitations = (subGroupID: number) => {
  return createSelector(
    sharedLib.sharedApi.admin.endpoints.getAdminSubGroupData.select({
      sub_group_id: subGroupID,
    }),
    ({ data: subGroup }) => {
      return subGroup ? subGroup.invitations : [];
    }
  );
};

export const selectSubGroupConfiguration = (subGroupID: number) => {
  return createSelector(
    sharedLib.sharedApi.admin.endpoints.getAdminSubGroupData.select({
      sub_group_id: subGroupID,
    }),
    ({ data: subGroup }) => {
      return subGroup?.configuration;
    }
  );
};
